import { Step } from '../components/steps/Step';
import { OnboardingFlows } from './common';

export const companySize: Step = {
    id: OnboardingFlows.CompanySize,
    title: 'How many people are in your company?',
    multiSelect: false,
    randomize: false,
    options: [
        {
            label: 'Only me',
        },
        {
            label: '2-10 employees',
        },
        {
            label: '11-50 employees',
        },
        {
            label: '51-200 employees',
        },
        {
            label: '201-500 employees',
        },
        {
            label: '501-1000 employees',
        },
        {
            label: '1001-5000 employees',
        },
        {
            label: '5001+ employees',
        },
    ],
};
